<template>
  <button type="button"
    class="btn-advanced-seeting-filter"
    data-toggle="dropdown"
    data-offset="25,5"
    aria-expanded="false">
    <SVGIcon iconName="icon-two-settings" key="icon-two-settingss" :size="18" class="fill-maino-blue"/>
  </button>
  <div class="dropdown-menu dropdown-menu-right advanced-settings-dropdown">
    <ul class="dropdown-main">
      <li v-for="item in items"
        :key="item.value"
        :class="{ 'selected': advancedSetting === item.value }"
        @click="handleClickItem(item.value)">
        {{ $i18n(item.label) }}
        <span class="selected-icon">
          <SVGIcon iconName="icon-check" :key="`icon-check-${item.value}`" :size="12" class="fill-maino-blue"/>
        </span>
      </li>
    </ul>
  </div>
</template>

<script setup>
  import { computed } from 'vue';
  import SVGIcon from '../../SvgIcon.vue';
  import { store } from '../store';
  const props = defineProps({
    campo: {
      type: Object,
      required: true
    }
  })

  const items = [
    {
      label: 'interface.novo_filtro.advanced_setting.include',
      value: 'include'
    },
    {
      label: 'interface.novo_filtro.advanced_setting.exact',
      value: 'exact'
    }
  ]

  const advancedSetting = computed(() => store.state.advancedSettings[props.campo.filtro]);

  const emits = defineEmits(['update:advancedSetting']);
  const handleClickItem = (value) => {
    store.commit('addAdvancedSetting', { filtro: props.campo.filtro, value: value });
    emits('update:advancedSetting', value);
  }
</script>
